import React from 'react'
import TopBar from '../../components/TopBar'
import BottomBar from '../../components/BottomBar'
import {
  currentLanguage,
  Translate,
  Norwegian,
  English,
} from '../../components/languageContext'
import './Spill.css'
import '../styles.css'

const mainTitleNO = 'Velkommen til Stjernekolonien!'
const mainTitleEN = 'Welcome to Star Colony!'

const topImageText1NO =
  'Et spill om bruk av digitale medier hvor du følger sjuåringene Luna eller Noah en uke i deres liv.'
const topImageText1EN =
  'A game about the use of digital media where you follow a week in the life of two 7-year-olds, Luna and Noah.'

const topImageText2NO =
  'I Stjernekolonien er noen ting annerledes enn på jorda, og noe er likt (for eksempel må man gå på skole også på andre planeter…). Din oppgave er å spille deg gjennom en uke i livet til én av karakterene i spillet.'
const topImageText2EN =
  'Some things are different in the Star Colony than on Earth and some are the same (e.g. children on other planets also have to go to school). Your task is to follow a week in the life of one of the characters in the game.'

const voksenTitleNO = 'Til deg som er voksen'
const voksenTitleEN = 'For adults'

const voksenTextNO =
  'Dette spillet skal du spille sammen med barnet ditt og dere skal løse oppgaver sammen. Underveis må dere snakke sammen, om hva som er lurt og ikke. Det er ikke alltid riktige eller gale svar, så derfor er det viktig at du og barnet ditt lytter til hverandre og finner frem til gode løsninger sammen. Kanskje lærer dere noe nytt sammen?'
const voksenTextEN =
  'This game is for you and your child to play together. As you solve tasks together, you will discuss what choices would be wise and not so wise. There are not always right or wrong answers, so it is important that you and your child listen to each other and work together to find good solutions. Maybe you can learn something new together?'

const barnTitleNO = 'Til deg som er barn'
const barnTitleEN = 'For children'

const barnTextNO =
  'Å bruke nett, mobil, spille dataspill eller bruke sosiale medier, er i utgangspunktet noe bra. Men av og til kan det bli feil eller vanskelig. I dette spillet kan du finne ut hva som kan være lurt å gjøre - og ikke gjøre - på nett. Du skal spille det sammen med foreldrene dine.'
const barnTextEN =
  'Using the internet, mobile phones and social media, and playing computer games can be great fun, but problems can also arise. This game shows you what to do – and not do – online. The game is for playing with your parents.'

const laererTitleNO = 'Til deg som er lærer'
const laererTitleEN = 'For teachers'

const laererTextNO =
  'Stjernekolonien er utviklet som et supplement til dialogdukene om digital dømmekraft. Målgruppen er barn mellom 6-9 år, og deres foreldre. Spillet kan enten spilles helt selvstendig, eller som et bindeledd mellom dialogduk 1 og 2. Stjernekolonien kan hjelpe foreldre og barn med samtalen om bruk av digitale medier.'
const laererTextEN =
  'Star Colony has been developed as a supplement to the conversation canvases on digital literacy. The target group is children aged 6-9 years and their parents. The game can either be played as a stand-alone game or as a link between conversations 1 and 2. Star Colony can serve as an aid for parents and children to discuss the use of digital media.'

const registerText =
  'Få et klassesett med tøffe Stjernekolonien-reflekser! Vi har 50 klassesett med reflekser som lærere kan dele ut til sin klasse.'

const praktiskInfoTitleNO = 'Litt praktisk om selve spillet'
const praktiskInfoTitleEN = 'Practical details about the game'

const praktiskInfoTextNO = [
  'Du velger hvilken figur du vil følge. Første gangen må du velge mellom Luna eller Noah.',
  'Figuren din havner i ulike situasjoner hvor du må gjøre noen valg. Ikke alle oppgaver har et riktig eller feil svar - her skal dere snakke sammen og finne ut hva som passer for deres familie.',
  'Hver spilleomgang tar ca. 30 minutter. Du kan spille så mange ganger du vil.',
  'Spillet tar opp temaer som skjermtid, nettvett, passord, aldersgrenser, oppførsel på sosiale medier og personvern – og at nettet er en fantastisk ressurs, når man bruker det riktig. Hver karakter havner i situasjoner som tar opp noen av disse temaene – men ikke alle. Derfor anbefaler vi at du spiller spillet flere ganger, men følger ulike personer.',
  'På slutten av hver karakters historie får du tilgang til å laste ned et bilde som kan printes ut og fargelegges.',
  'Spillet er utviklet for å spilles på pc eller nettbrett.',
]
const praktiskInfoTextEN = [
  'You choose which character you want to follow. The first time you play, you will choose between Luna or Noah.',
  'Your character will end up in different situations where you have to make some choices. Not all tasks have a right or wrong answer – you need to discuss them with your family and agree on a solution.',
  'Each game takes about 30 minutes, and you can play as many times as you like.',
  'The game addresses issues such as screen time, safe use of the internet, passwords, age limits, behaviour on social media and privacy. It shows how the internet can be a fantastic resource when used correctly. Each character ends up in situations that address some of these topics, but not all. We recommend that you play the game several times, but follow different people so that you can cover all the topics.',
  'At the end of each character’s story, you will be able to download a picture that can be printed and coloured in.',
  'The game is designed to be played on a computer or tablet.',
]
const bottomTextNO =
  `Stjernekolonien er utviklet av Specifique, på oppdrag fra Medietilsynet, snakkomspill.no, Ombudet for barn og unge i Akershus, Buskerud og Østfold, og er delfinansiert av Handlingsplanen mot spilleproblemer og EU gjennom Connecting Europe Facility.`
const bottomTextEN =
  'Star Colony is developed by Specifique, as requested by The Norwegian Media Authority, snakkomspill.no, The ombud for children and young people in Akershus, Buskerud and Østfold, and is partly financed by the “Action plan against gaming and gambling problems” and the EU through Connecting Europe Facility.'
class Spill extends React.Component {
  spillGame = () => {
    window.location = 'https://spill.dommekraft.no' + window.location.search
  }

  register = () => {
    window.location =
      'https://www.medietilsynet.no/digitale-medier/barn-og-medier/stjernekolonien--et-digitalt-familiespill-om-livet-pa-nett/'
  }

  render() {
    const praktiskInfoText =
      currentLanguage === 'NO' ? praktiskInfoTextNO : praktiskInfoTextEN
    return (
      <div className="OuterContainer">
        <div style={{ display: 'block' }}>
          <TopBar activePage={'Spill'} />
        </div>
        <div className="spill-container">
          <div className="spill-block1-container">
            <div className="spill-main-title">
              <Translate>
                <Norwegian>{mainTitleNO}</Norwegian>
                <English>{mainTitleEN}</English>
              </Translate>
            </div>
            <div className="spill-first-block-container">
              <img
                src={require('./static/some-luna-noah-nologo.png')}
                alt=""
                className="spill-normal-image"
              />
              <div className="spill-top-image-text-container">
                <div className="spill-top-image-text1">
                  <Translate>
                    <Norwegian>{topImageText1NO}</Norwegian>
                    <English>{topImageText1EN}</English>
                  </Translate>
                </div>
                <div className="spill-top-image-text2">
                  <Translate>
                    <Norwegian>{topImageText2NO}</Norwegian>
                    <English>{topImageText2EN}</English>
                  </Translate>
                </div>
                <button className="spill-button" onClick={this.spillGame}>
                  <Translate>
                    <Norwegian> Spill det her </Norwegian>
                    <English>Play here</English>
                  </Translate>
                </button>
              </div>
            </div>
            <div className="spill-images-block">
              <Translate>
                <Norwegian>
                  <img
                    src={require('./static/gameplay1.png')}
                    alt=""
                    className="spill-normal-image"
                  />
                </Norwegian>
                <English>
                  <img
                    src={require('./static/gameplay1-en.png')}
                    alt=""
                    className="spill-normal-image"
                  />
                </English>
              </Translate>
              <Translate>
                <Norwegian>
                  <img
                    src={require('./static/Gameplay2.png')}
                    alt=""
                    className="spill-normal-image"
                    style={{ marginLeft: 30 }}
                  />
                </Norwegian>
                <English>
                  <img
                    src={require('./static/gameplay2-en.png')}
                    alt=""
                    className="spill-normal-image"
                    style={{ marginLeft: 30 }}
                  />
                </English>
              </Translate>
              <Translate>
                <Norwegian>
                  <img
                    src={require('./static/gameplay3.png')}
                    alt=""
                    className="spill-normal-image"
                    style={{ marginLeft: 30 }}
                  />
                </Norwegian>
                <English>
                  <img
                    src={require('./static/gameplay3-en.png')}
                    alt=""
                    className="spill-normal-image"
                    style={{ marginLeft: 30 }}
                  />
                </English>
              </Translate>
            </div>
          </div>
          <div className="spill-block2-container">
            <div className="spill-block2-inner-container">
              <div className="spill-voksen-barn-container">
                <div className="spill-bilde-og-text-blokk">
                  <div className="spill-character-images-container">
                    <img
                      src={require('./static/edan.png')}
                      alt=""
                      className="spill-character-image"
                    />
                    <img
                      src={require('./static/sara.png')}
                      alt=""
                      className="spill-character-image spill-character-image-right"
                    />
                  </div>
                  <div className="spill-box-padding" >
                    <div className="spill-box-title">
                      <Translate>
                        <Norwegian>{voksenTitleNO}</Norwegian>
                        <English>{voksenTitleEN}</English>
                      </Translate>
                    </div>
                    <div className="spill-box-text">
                      <Translate>
                        <Norwegian>{voksenTextNO}</Norwegian>
                        <English>{voksenTextEN}</English>
                      </Translate>
                    </div>
                  </div>
                </div>
                <div
                  className="spill-bilde-og-text-blokk"
                  style={{ marginLeft: 22 }}
                >
                  <div className="spill-character-images-container">
                    <img
                      src={require('./static/luna.png')}
                      alt=""
                      className="spill-character-image"
                    />
                    <img
                      src={require('./static/noah.png')}
                      alt=""
                      className="spill-character-image spill-character-image-right"
                    />
                  </div>
                  <div className="spill-box-padding" >
                    <div className="spill-box-title">
                      <Translate>
                        <Norwegian>{barnTitleNO}</Norwegian>
                        <English>{barnTitleEN}</English>
                      </Translate>
                    </div>
                    <div className="spill-box-text">
                      <Translate>
                        <Norwegian>{barnTextNO}</Norwegian>
                        <English>{barnTextEN}</English>
                      </Translate>
                    </div>
                  </div>
                </div>
              </div>

              <div className="spill-laerer-container">
                <Translate>
                  <Norwegian>
                    <img
                      src={require('./static/gameplay4.png')}
                      alt=""
                      className="spill-laerer-bilde"
                      style={{ marginLeft: 30 }}
                    />
                  </Norwegian>
                  <English>
                    <img
                      src={require('./static/gameplay4-en.png')}
                      alt=""
                      className="spill-laerer-bilde"
                      style={{ marginLeft: 30 }}
                    />
                  </English>
                </Translate>
                <div className="spill-laerer-content">
                  <div className="spill-box-title" style={{ textAlign: 'left' }}>
                    <Translate>
                      <Norwegian>{laererTitleNO}</Norwegian>
                      <English>{laererTitleEN}</English>
                    </Translate>
                  </div>
                  <div className="spill-box-text">
                    <Translate>
                      <Norwegian>{laererTextNO}</Norwegian>
                      <English>{laererTextEN}</English>
                    </Translate>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className="spill-praktisk-info-container">
            <div className="spill-praktisk-info-inner-container">
              <div className="spill-praktisk-info-title">
                <Translate>
                  <Norwegian> {praktiskInfoTitleNO}</Norwegian>
                  <English> {praktiskInfoTitleEN}</English>
                </Translate>
              </div>
              <div className="spill-praktisk-info-points">
                {praktiskInfoText.map((text, index) => (
                  <div key={index} className="spill-praktisk-info-text">
                    <img
                      src={require('./static/star.svg')}
                      alt=""
                      className="spill-star-image"
                      style={{ transform: `rotate(${index * 32}deg)` }}
                    />
                    {text}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="spill-bottom-container">
            <div className="spill-bottom-text">
              <Translate>
                <Norwegian>{bottomTextNO}</Norwegian>
                <English> {bottomTextEN}</English>
              </Translate>
            </div>
          </div>
          <BottomBar />
        </div>
      </div>
    )
  }
}
export default Spill



// WEBPACK FOOTER //
// ./src/pages/Spill/index.js